import React from 'react';
import { FaReact, FaDocker, FaPython, FaJs, FaCss3Alt, FaHtml5, FaWordpress } 
from 'react-icons/fa';
import { SiKubernetes, SiGitlab, SiAnsible, SiTerraform, SiRancher, SiHelm, SiDjango, SiBootstrap, SiGrafana, SiPrometheus } from 'react-icons/si';
import { BsDatabase } from 'react-icons/bs';
import './Skills.css';
import { FaC } from 'react-icons/fa6';


function Skills() {
  const categories = [
    {
      title: "Outils DevOps",
      skills: [
        { name: "Docker", icon: <FaDocker className="skill-icon" /> },
        { name: "Kubernetes", icon: <SiKubernetes className="skill-icon" /> },
        { name: "Gitlab CI/CD", icon: <SiGitlab className="skill-icon" /> },
        { name: "Ansible", icon: <SiAnsible className="skill-icon" /> },
        { name: "Terraform", icon: <SiTerraform className="skill-icon" /> },
        { name: "Rancher", icon: <SiRancher className="skill-icon" /> },
        { name: "Helm", icon: <SiHelm className="skill-icon" /> }
      ]
    },
    {
      title: "Langages de Programmation",
      skills: [
        { name: "Python", icon: <FaPython className="skill-icon" /> },
        { name: "JavaScript", icon: <FaJs className="skill-icon" /> },
        { name: "C", icon: <FaC className="skill-icon" /> },
        { name: "HTML", icon: <FaHtml5 className="skill-icon" /> },
        { name: "CSS", icon: <FaCss3Alt className="skill-icon" /> },
      ]
    },
    {
      title: "Frameworks et Bibliothèques",
      skills: [
        { name: "Django", icon: <SiDjango className="skill-icon" /> },
        { name: "React", icon: <FaReact className="skill-icon" /> },
        { name: "Bootstrap", icon: <SiBootstrap className="skill-icon" /> },
        { name: "WordPress", icon: <FaWordpress className="skill-icon" /> }
      ]
    },
    {
      title: "Autres",
      skills: [
        { name: "PostgreSQL", icon: <BsDatabase className="skill-icon" /> },
        { name: "Grafana", icon: <SiGrafana className="skill-icon" /> },
        { name: "Prometheus", icon: <SiPrometheus className="skill-icon" /> },
        { name: "Réseaux et Sécurité", icon: <BsDatabase className="skill-icon" /> },
      ]
    }
  ];

  return (
    <section id="skills">
      <h1 className="skills-title">COMPETENCES</h1>
      <div className="container">
        <div className="row">
          {categories.map((category, index) => (
            <div key={index} className="col-md-6 mb-4">
              <div className="category-card">
                <h2 className="category-title">{category.title}</h2>
                <div className="skills-list">
                  {category.skills.map((skill, idx) => (
                    <div key={idx} className="skill-card">
                      {skill.icon}
                      <p className="skill-name">{skill.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



export default Skills;